<div class="d-flex justify-content-between">
    <div
        class="d-flex align-items-center gap-4 mt-2 mb-3"
        (mouseenter)="onHeaderMouseEnter()"
        (mouseleave)="onHeaderMouseLeave()">
        <div class="carousel-title primary-text fw-bold font-6">
            <ng-content select="[carousel-label]"></ng-content>
        </div>
        @if (showActions()) {
            <div [@fadeInOut]>
                <ng-content select="[carousel-action]"></ng-content>
            </div>
        }
    </div>

    <!-- <div class="indicator-container" *ngIf="totalPages() > 1">
        <div 
            *ngFor="let page of pagesArray()" 
            class="indicator"
            [class.active]="currentPage() === page"
            (click)="goToPage(page)">
        </div>
    </div> -->
</div>

<div class="carousel-container mb-4">
    <div class="carousel-list">
        @if (!isEmpty()) {
            <ul
                class="slider-content"
                #sliderContent>
                <li
                    *ngFor="let item of virtualItems(); let i = index; trackBy: trackByFn"
                    class="slide-item"
                    (mouseenter)="select(item.data.id)"
                    [style.view-transition-name]="item.data.id === selectedId() ? 'card-image-' + item.data.id : 'none'"
                    [ngStyle]="itemStyle()"
                    [ngClass]="{ active: isVisible(item.originalIndex), 'hover-enabled': enableHover() } ">
                    <carousel-item 
                        [shouldAddBreadcrumb]="shouldAddBreadcrumb()"
                        [enableHover]="enableHover()" 
                        [showCount]="showCount()"
                        [showSelection]="showSelection()" 
                        [data]="item.data"></carousel-item>
                </li>
            </ul>
        } @else {
            <div class="clip4 clip4-corner bg-white-75 primary-border rounded-1 empty">No Data</div>
        }
    </div>
    @if (!isEmpty()) {
        @if (canGoPrev()) {
            <div
                (click)="prev()"
                class="carousel-control-prev">
                <prev-icon class="carousel-prev-icon" />
            </div>
        }

        @if (canGoNext()) {
            <div
                (click)="next()"
                class="carousel-control-next">
                <next-icon class="carousel-next-icon" />
            </div>
        }
    }
</div>
